
import { defineComponent } from "vue";
import Grid from "@moonlight/vue3/components/Grid.vue";

export default defineComponent({
  components: {
    Grid,
  },
});
